module.exports = __webpack_public_path__ + "img/icon-down.27733c51.svg";